module.exports = __webpack_public_path__ + "static/media/STAF_nynorsk_sentrert logo_pos(svart).2486de94.png";